import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // In a real app, clear auth tokens here
    navigate('/admin');
  };

  return (
    <div className="admin-sidebar">
      <div className="sidebar-header">
        <h2>Densat Admin</h2>
      </div>

      <nav className="sidebar-nav">
        <Link to="/admin/dashboard" className="sidebar-link">
          <span className="link-icon">📊</span>
          Dashboard
        </Link>

      
         <Link to="/admin/blogs" className="sidebar-link">
          <span className="link-icon">📝</span>
          Blogs
        </Link>

        <Link to="/admin/settings" className="sidebar-link">
          <span className="link-icon">⚙️</span>
          Settings
        </Link>

       
      </nav>

      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <span className="link-icon">🚪</span>
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;
